import React from "react";
import { Link } from "react-router-dom";
import { FaqMain, FaqSection, FaqWrapper } from "../components/Faq/Faq.styled";

export const FaqPage = () => {
  return (
    <FaqWrapper>
      <div className='container'>
        <FaqMain>
          <h2>Tontake FAQ</h2>
          <span>June 1, 2022</span>
          <FaqSection>
            <h3>1. What is Tontake, and how do I use the site?</h3>
            <p>
              Getgems is an NFT marketplace whose “home” is based on The Open Network blockchain. The project was founded by crypto enthusiasts who
              are passionate about NFTs, DeFi, and the technology of the future.
            </p>
            <p>
              To start using the site, all you need to do is connect your wallet — and that’s it. You’ll have all o the site’s functionalities at your
              fingertips — buying, selling, minting, and transferring single NFTs or entire collections. If you’re more of an observer, there’s plenty
              of NFT beauty on the marketplace to feast with your eyes!
            </p>
          </FaqSection>
          <FaqSection>
            <h3>2. What’s an NFT?</h3>
            <p>An NFT, or nonfungible token, is a digital contract, a “maker,” that indicates who owns what digital asset and its creator.</p>
          </FaqSection>
          <FaqSection>
            <h3>3. What is The Open Network (TON)?</h3>
            <p>
              Getgems is based on The Open Network blockchain, a next-generation Web3 blockchain ecosystem created from the ground up to make digital
              life easier. If you’re an NFT artist or collector, TON is the ideal instrument for you, thanks to its high performance and low
              transaction fees.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>4. How is getgems.io better than other NFT marketplaces?</h3>
            <p>
              The main aspect of the TON blockchain that sets it apart from other blockchain networks is its ability to settle transactions almost
              instantly and for extremely low fees. This one feature is what speaks the most to those who are unwilling to pay exorbitant transaction
              fees on other networks and wait for confirmations.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>5. Why do we need NFTs?</h3>
            <p>
              NFTs allow people to create a unique certificate containing a digital signature connected to an asset on a blockchain. Such technology
              opens the floodgates to a wide array of use cases, from artwork to domain names. NFTs are a convenient layer serving all kinds of
              content. The main takeaway is that it proves uniqueness and confirms the ownership of a specific NFT.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>6. If anyone can simply download a picture, what’s the point of buying an NFT?</h3>
            <p>
              The answer to that question lies in the concept of NFTs. Yes, you can, in fact, simply download whatever picture you can find on the
              internet. However, it’s next to impossible to determine who owns the original, except for the owner of the NFT, which means that the
              NFT’s value rests in the hands of its owner — and no one else.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>7. How do I buy an NFT on Tontake?</h3>
            <p>
              All you have to do to start buying NFTs is connect your wallet via the TON Wallet browser extension. The rest happens automatically.
              However, make sure you have enough funds in your wallet before making a purchase, and last but not least, find something you love and
              buy it!
            </p>
          </FaqSection>
          <FaqSection>
            <h3>8. How do I receive an NFT?</h3>
            <p>
              After buying an NFT, the information regarding the transfer of ownership will be saved on the blockchain, and you’ll be able to view
              this data directly on the Tontake site in the section called “My Collections” or in any wallet that has NFT support.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>9. What does “gas” mean, and what’s it for?</h3>
            <p>
              Gas is another word used for “transaction fee” when making a transaction or interacting with a smart contract on a blockchain. Unlike
              many blockchain networks, gas fees on TON are remarkably low — one of TON’s biggest advantages over its competitors.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>10. Can I transfer an NFT to a friend?</h3>
            <p>
              Yes! You can do more than just sell an NFT for a concrete price. You can transfer it to a friend by simply taking care of the
              transaction fee.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>11. I’ve bought an NFT. What’s next?</h3>
            <p>
              The world is your oyster. Save it, sell it, add more NFTs to your collection, or trade it. You’re the sole owner and in full control of
              what happens to it. Do whatever you want with it.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>12. I have a purchased NFT, how can I list it for sale through Tontake?</h3>
            <p>
              Nothing prevents the owned NFT from disposing on our market the way you want, including laying it out for sale. If it is on the wallet
              and is displayed with us, you can lay it out exactly according to the same scheme as with a regular minting.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>13. Can I buy an NFT with fiat currency?</h3>
            <p>
              No. All transactions are only in Toncoin (TON). That’s why we mention above that when you first get a TON-based wallet, you need to
              deposit some funds first — Toncoin — then you can buy NFTs.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>14. Why do I need a crypto wallet?</h3>
            <p>
              Crypto wallets play the same role as regular wallets in which you keep banknotes. In it, you can store your NFTs and Toncoin and use it
              to send and receive TON.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>15. How do I get a crypto wallet?</h3>
            <p>
              It’s quite simple. Download the browser extension for <a href=''>TON Wallet</a> or the <a href=''>Tonkeeper</a> app for iOS and Android
              mobile devices. Next, follow the easy registration steps when creating your new wallet and make sure you write down the 24-word recovery
              phrase on a piece of paper and keep it in a safe place. Never share this phrase with anyone because it’ll grant them direct access to
              your crypto and NFTs. And that’s it! You’re now ready to use your wallet.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>16. How to fund my wallet with TON?</h3>
            <p>
              You can buy TON on crypto exchanges, trough crypto bot or via <a href='https://tonkeeper.com/'>Tonkeeper</a>. Find more information
              about purchasing TON, on <a href='https://ton.org/'>ton.org</a> official website.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>17. Is it safe to sign in to Tontake via my wallet?</h3>
            <p>
              Absolutely! When signing in, we still have no access to the contents — crypto, NFTs, etc. — of your wallet. We only see its unique ID to
              verify who enters the marketplace.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>18. How can I register on getgems.io?</h3>
            <p>
              The Tontake marketplace does not require a typical registration process. To become a marketplace user, you only need to connect your
              wallet, and a wallet address is used as a unique identifier. You just need to log in to the marketplace with it.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>19. Are there auctions on Tontake?</h3>
            <p>Not at the moment, but this is one of the features we are going to launch in the near future.</p>
          </FaqSection>
          <FaqSection>
            <h3>20. What other fees do I need to pay?</h3>
            <p>When placing NFTs for sale, you are required to pay a service fee and gas — but that’s it.</p>
          </FaqSection>
          <FaqSection>
            <h3>21. When buying, only the transaction fee is to be paid?</h3>
            <p>
              Please remember, for any operation with NFTs (buying or selling), you need to have at least 1 TON in your wallet to pay the gas fee. The
              blockchain returns most of this amount back since the fee amount varies slightly from transaction to transaction due to the ways the TON
              blockchain operates.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>22. How do I mint an NFT on Tontake?</h3>
            <p>You can find more information in Mint Page.</p>
          </FaqSection>
          <FaqSection>
            <h3>23. How can I add my collection to Tontake?</h3>
            <p>
              There are two ways to do so: You can mint a collection directly through the site’s interface. The process is as simple as uploading
              <ul>
                <li>photos to your social media accounts: You just log in, choose pics you’d like to mint — as a single NFT or a collection — and</li>
                <li>
                  set the necessary parameters. You can list the collection. Just add it to the “Added” list on the marketplace without actually
                  minting the collection.
                </li>
              </ul>
            </p>
          </FaqSection>
          <FaqSection>
            <h3>24. How can my collection be placed on the main page? Why can’t I see my collection on the main page after I’ve minted it?</h3>
            <p>
              Once you’ve minted a collection, it won’t automatically appear on our main page. For now, we’re going through all submissions and
              hand-picking ones to be displayed on Tontake’ main page. Among NFT art minted on the blockchain, there is also illegal content,
              unfortunately. We want to clarify that we have no interest in allowing the latter to be published on our marketplace. When we’re in the
              process of deciding what gets added to our platform, we consider the following:
              <ul>
                <li>The collection has at least 10 NFTs created in the same thematic style. </li>
                <li>The NFTs in the collection must be up for sale. </li>
                <li>
                  The collection must be original. If it has too many similarities to other projects, or someone else’s art is being used, we’ll
                  reject it.
                </li>
              </ul>
            </p>
          </FaqSection>
          <FaqSection>
            <h3>25. What is minting, and why does one need to do it?</h3>
            <p>
              Minting is the process of turning a picture into an NFT and placing it on the blockchain. During the minting process, an address is
              assigned to the NFT, and a place on the blockchain is allocated. Minting costs a certain amount of cryptocurrency (a “gas” or
              transaction fee), but on TON, this cost is very low.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>26. How much does minting cost?</h3>
            <p>
              Minting one NFT will cost you 0.05 TON for gas + 0.02 TON for a service fee = 0.07 TON. Minting a collection of 1,000 NFTs will cost 70
              TON (the price might vary).
            </p>
          </FaqSection>
          <FaqSection>
            <h3>27. What are royalties, and how are they paid?</h3>
            <p>
              A royalty is a fee that an NFT creator receives each time their NFT is sold. In fact, this is a way to receive a fixed percentage from
              each NFT sale on the secondary market. Royalties on getgems.io may vary from 0% to 50% — whatever percentage the creator decides to set.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>28. What does “floor price” mean?</h3>
            <p>The floor price of an NFT is its lowest price on the market.</p>
          </FaqSection>
          <FaqSection>
            <h3>29. How can I predict the growth of an NFT’s price?</h3>
            <p>
              There’s no way to predict it reliably and with 100% accuracy. First of all, an NFT is an instrument and something to collect. Only then
              does it become a means of investment through which one can perhaps one day make a profit. By keeping a finger on the pulse of the
              market, you can make better assumptions and decisions regarding earning profits, but there are always risks and almost no guarantees.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>30. Is it safe to buy NFTs?</h3>
            <p>
              Buying NFTs is safe, but there is no guarantee that it will be a profitable investment. Some see it as a good way to support artists and
              grow their collections, and occasionally, it might turn into a profitable investment.
            </p>
          </FaqSection>
          <FaqSection>
            <h3>31. How do I know if I’m being scammed when buying NFTs?</h3>
            <p>
              There’s no “secret rule” to be 100% sure. NFTs on TON are deeply rooted in community interaction, and we believe that the percentage of
              fraud will be low because there is no need for such a tight community to scam one another. However, no one is safe from deception. Our
              advice is: always do your own research (DYOR). You should not take risks and invest your money in something that you are not sure about.
              You can read more about safety in our <Link to='/disclaimer'>Disclaimer</Link>.
            </p>
          </FaqSection>
        </FaqMain>
      </div>
    </FaqWrapper>
  );
};
